module.exports = __webpack_public_path__ + "img/icon_earth_active.94c735f7.svg";